import MonthlyEarningsGapsFilter from "./MonthlyEarningsGapsFilter";
import MonthlyEarningsGapsItem from "./MonthlyEarningsGapsItem";

const MonthlyEarningsGaps = () => {
  return (
    <>
      <MonthlyEarningsGapsFilter />
      <MonthlyEarningsGapsItem />
    </>
  );
};

export default MonthlyEarningsGaps;
